import cx from 'classnames'
import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Select from 'react-select-plus'
import LoadingDots from 'shared-web/src/components/Loading'
import { Button } from '@driftt/tide-core-legacy'

import WarningModal from '../WarningModal'

import { getIsGoogleOauthConnected, getCalendar, getCalendars } from 'app/modules/meetings/selectors'
import {
  fetchCalendarStatus,
  updateGoogleCalendar,
  disconnectGoogleCalendar,
  updateMeetingSettings,
} from 'app/modules/meetings/actions'
import { actions as TrackingActions } from 'app/modules/tracking'
import { encodeQueryData } from 'utils/Helpers'
import { popUp } from 'components/Integration/helpers'
import { getApplication } from 'app/Application'
import { APP_URL, GOOGLE_CLIENT_ID } from 'constants/ResourcesConstants'
import { GoogleScopes } from 'app/modules/integrations/constants'

import styles from './style.styl'

import googleGSrc from 'images/onboarding/google-G-logo_L.svg'

const APP = getApplication()

class GoogleOAuthConnect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pending: false,
      showDisconnectModal: false,
    }
  }

  componentWillMount() {
    const { calendars } = this.props

    if (calendars.size === 1) {
      this.handleSaveClick({ calId: calendars.getIn([0, 'id']) })
    }
  }

  getCalendarConnectionSource = () => {
    const params = new URL(window.location).searchParams
    return params.get('source') || 'organic'
  }

  handlePostMessage = e => {
    const { onSuccess, actions: { track }} = this.props
    const success = e.data.status === 'success'

    if (success) {
      this.setState({ pending: false }, () => {
        APP.actions.NotificationActions.pushNotification({
          content: 'Your Google account was successfully connected.',
        })
        track('Calendar Connected', { context: 'settings', source: this.getCalendarConnectionSource() })
        this.trackEvent('Calendar Setup', { action: 'connected' })
        this.props.actions.fetchCalendarStatus()
      })
      !!onSuccess && onSuccess(e)
    } else {
      this.setState({ pending: false }, () => {
        this.props.setGooglePermissionErrorState(true)
      })
    }
  }

  handleConnectClick = () => {
    this.setState({
      pending: true,
    })

    const params = {
      redirect_uri: `${APP_URL}/accept-integration/google-calendar`,
      client_id: GOOGLE_CLIENT_ID,
      response_type: 'code',
      access_type: 'offline',
      include_granted_scopes: true,
    }

    if (this.props.includeEmailScopes) {
      params.scope = `${GoogleScopes.CALENDAR} ${GoogleScopes.SEND} ${GoogleScopes.READ}`
    } else {
      params.scope = GoogleScopes.CALENDAR
    }

    popUp({
      path: `https://accounts.google.com/o/oauth2/v2/auth?${encodeQueryData(params)}`,
      onMessage: this.handlePostMessage,
    })
  }

  trackEvent = (name, attributes) => {
    this.props.actions.track(name, {
      context: 'settings',
      service: 'google-calendar',
      ...attributes,
    })
  }

  handleSaveClick = ({ calId }) => {
    const { onSave, calendars, actions } = this.props
    const selectedCalendarId = !!calId ? calId : this.getSelectedCalendarId()
    const calendar = calendars.find(calendar => calendar.id === selectedCalendarId)
    if (!!calendar) {
      actions.updateCalendar(calendar)
      this.trackEvent('Calendar Setup', { action: 'updated-calendar', selectedCalendarId })
      window.drift && window.drift.on('ready', (api) => {
        api.setUserAttributes({ first_calendar_connect: true })
      })
      !!onSave && onSave()
    }
  }

  handleShowDisconnectModal = () => {
    this.setState({
      showDisconnectModal: true,
    })
  }
  handleHideDisconnectModal = () => {
    this.setState({
      showDisconnectModal: false,
    })
  }

  handleDisconnectClick = e => {
    const { disconnectCallback } = this.props
    e.preventDefault()

    this.setState(
      {
        calendarId: undefined,
      },
      () => {
        this.props.actions.disconnectCalendar()
        this.trackEvent('Calendar Setup', { action: 'disconnected' })
        !!disconnectCallback && disconnectCallback()
      }
    )
  }

  handleCalendarSelect = ({ value }) => {
    const { autoSaveSelect } = this.props
    this.setState(
      {
        calendarId: value,
      },
      () => {
        autoSaveSelect && this.handleSaveClick({ calId: value })
      }
    )
  }

  getSelectedCalendarId = () => {
    if (this.state.calendarId) {
      return this.state.calendarId
    }

    if (this.props.calendar.id) {
      return this.props.calendar.id
    }
  }

  renderButton() {
    const { pending } = this.state
    const { buttonLabel } = this.props
    return (
      <button
        className="drift-button drift-button-primary"
        style={{ marginLeft: 'auto' }}
        onClick={this.handleConnectClick}
        disabled={pending}
      >
        {pending ? (
          <div className="flex flex-center">
            Connecting <LoadingDots style={{ marginLeft: '0.5rem' }} size="small" />
          </div>
        ) : (
          buttonLabel || 'Connect'
        )}
      </button>
    )
  }

  renderNotConnected() {
    const { minimalUI } = this.props

    if (minimalUI) {
      return this.renderButton()
    }

    return (
      <div className={styles.OAuthConnect}>
        <div className="service-icon">
          <img src={googleGSrc} alt="google logo" />
        </div>
        <div className="service-info media-body">
          <div className="service-name">Google Calendar</div>
          <div className="service-description">
            Allows Drift to check your Google Calendar for conflicts and add events to it.
          </div>
        </div>
        <div style={{ marginLeft: 'auto', paddingLeft: '1.5rem' }}>{this.renderButton()}</div>
      </div>
    )
  }

  renderCalendarSelect = () => {
    const { calendars, withDisconnect } = this.props
    const { showDisconnectModal } = this.state
    const selectedCalendarId = this.getSelectedCalendarId()
    return (
      <div className="minimal-ui">
        <Select
          className="minimal-calendar-select"
          value={selectedCalendarId}
          searchable={false}
          clearable={false}
          placeholder="Pick a calendar to connect..."
          options={calendars
            .map(calendar => {
              return { value: calendar.id, label: calendar.name }
            })
            .toArray()}
          onChange={this.handleCalendarSelect}
        />
        {withDisconnect && <button className="tide-button medium utility-button minimal-ui-disconnect" onClick={this.handleShowDisconnectModal}>Disconnect</button>}
        {withDisconnect &&
          showDisconnectModal && (
            <WarningModal
              handleCloseModal={this.handleHideDisconnectModal}
              handleDisconnect={this.handleDisconnectClick}
            />
          )}
      </div>
    )
  }

  renderConnected() {
    const {
      googleAuthed,
      minimalUI,
      buttonLabel,
      title,
      withDisconnect = false,
      autoSaveSelect = false,
      hideIcon = false,
    } = this.props

    if (minimalUI) {
      return this.renderCalendarSelect()
    }

    const { pending, showDisconnectModal } = this.state
    const selectedCalendarId = this.getSelectedCalendarId()
    return (
      <div className={styles.OAuthConnect}>
        {!hideIcon && <div className="service-icon">
          <img src={googleGSrc} alt="google logo" />
        </div>}
        <div className={cx("service-info media-body", { 'hide-icon': hideIcon })}>
          {!hideIcon && <div className="service-name">{!!title ? title : 'Google Calendar'}</div>}
          <div className="drift-form">
            <div className="calendar-selector-wrapper">
              <div className="calendar-select-inner">{this.renderCalendarSelect()}</div>
              {withDisconnect && (
                <Button
                  type="danger"
                  size="small"
                  disabled={!googleAuthed}
                  onClick={this.handleShowDisconnectModal}
                >
                  Disconnect
                </Button>
              )}
              {!autoSaveSelect && (
                <Button
                  onClick={this.handleSaveClick}
                  disabled={!selectedCalendarId}
                  loading={pending}
                >
                  {!!buttonLabel ? buttonLabel : 'Save'}
                </Button>
              )}
            </div>
          </div>
        </div>
        {withDisconnect &&
          showDisconnectModal && (
            <WarningModal
              handleCloseModal={this.handleHideDisconnectModal}
              handleDisconnect={this.handleDisconnectClick}
            />
          )}
      </div>
    )
  }

  render() {
    const { googleAuthed, isMissingScopes } = this.props
    if (!googleAuthed || isMissingScopes) {
      return this.renderNotConnected()
    } else {
      return this.renderConnected()
    }
  }
}

const mapStateToProps = (state) => {
  return {
    googleAuthed: getIsGoogleOauthConnected(state),
    calendar: getCalendar(state),
    calendars: getCalendars(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        fetchCalendarStatus,
        updateCalendar: updateGoogleCalendar,
        disconnectCalendar: disconnectGoogleCalendar,
        updateMeetingSettings,
        track: TrackingActions.track,
      },
      dispatch
    ),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GoogleOAuthConnect)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/GoogleOAuthConnect/index.js